import { render } from "./TheBookRefundFooter.vue?vue&type=template&id=bc362014"
import script from "./TheBookRefundFooter.vue?vue&type=script&lang=js"
export * from "./TheBookRefundFooter.vue?vue&type=script&lang=js"
script.render = render

export default script